import React, { useState, useEffect } from 'react';
import { useParams , useNavigate, useLocation} from 'react-router-dom';
import {
    Stack, Button, Box, Grid, Card, CardContent, CardActions, Paper,
    CircularProgress, Popover, Typography, Divider, MenuItem,
    List, ListItemButton, ListItemIcon, ListItemText, Collapse, ListSubheader,
    IconButton,
} from '@mui/material';
import client from '../common/client.js';
import { getSelectedProject } from '../common/common.js'

import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import { useTheme } from "@mui/material/styles";
import AddIcon from '@mui/icons-material/Add';

const ProjectExplore = props => {
    const location = useLocation()
    const navigate = useNavigate();
    const theme = useTheme();
    
    const [open, setOpen] = React.useState(true);
    const [list, setList] = React.useState([]);
    const [blockList, setBlockList] = React.useState([]);
    const [screen_id, setScreen_id] = useState('');

    const handleClick = () => {
        setOpen(!open);
    };

    useEffect(() => {
        const search = location.search;
        const query = new URLSearchParams(search)
        setScreen_id(query.get('screen_id'))
    }, null)

    useEffect(() => {
        client.request_get(`/screen?_end=300&project_id=` + getSelectedProject()).then(screen_list => {
            setList(screen_list)
            client.request_get(`/block?_end=300&project_id=` + getSelectedProject()).then(all_block_list => {
                if(!Array.isArray(all_block_list))
                    return
                setList(screen_list)
                let block_list = []
                all_block_list && all_block_list.map(m => {
                    let found = screen_list.find(f=>f.block_list && f.block_list.length > 0 && f.block_list[0].block_id == m.id)
                    if(!found)
                        block_list.push(m)
                })
                setBlockList(block_list)
            })
        })
    }, [props.refreshIndex])

    const onClickScreen = (m) => {
        // /#/ide?screen_id={m.id} 로 이동
        if(m.block_list.length > 0)
            navigate(`/ide?screen_id=${m.id}&block_id=${m.block_list[0].block_id}`)
        else 
            navigate(`/ide?screen_id=${m.id}`)
    }
    const onClickBlock = (m) => {
        navigate('/ide?block_id=' + m.id)
    }
    const onClicNewkScreen = () => {
        navigate('/ide/new')
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <List
                sx={{ width: '100%', height: '100%', overflow: 'auto',}}
                component="nav"
                subheader={
                    <ListSubheader>
                        <Box sx={{display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                            Screens
                            <IconButton onClick={onClicNewkScreen}><AddIcon/></IconButton>
                        </Box>
                    </ListSubheader>
                }
            >
                {
                    list.map((m, index) => {
                        //console.log('screen_id', screen_id)
                        return (
                        <ListItemButton key={m.id} onClick={()=>onClickScreen(m)}>
                            <ListItemText primary={m.name} sx={{
                                paddingLeft:'10px',
                                color:(screen_id==m.id?theme.palette.primary.main:null)}}/>
                        </ListItemButton>
                    )})
                }
                <Divider/>

                <ListSubheader>
                <Box sx={{display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                            Blocks
                            <IconButton><AddIcon/></IconButton>
                        </Box>
                    </ListSubheader>
                {
                    blockList.map(m => (
                        <ListItemButton key={m.id} onClick={()=>onClickBlock(m)}>
                            <ListItemText primary={m.name}/>
                        </ListItemButton>
                    ))
                }
            </List>
        </Box>
    );
};

export default ProjectExplore;
